import React from 'react';
import styled from 'styled-components';
import { type PublicationFormProps } from './types';
import { APPLICATION_TEXT } from '../../lang';
import { DocumentBox } from '../../../../../components';
import {
  isNotPaper,
  ApplicantPublicationRole,
  PublicationTypesOptions,
  ApplicantRoleOptions,
  PublicationStatusOptions,
} from '../../../../Application/components';
import { getOptionsLabel } from '../../getOptionsLabel';

const PUBLICATION = APPLICATION_TEXT.PUBLICATION;
export const PublicationForm: React.FunctionComponent<PublicationFormProps> = (
  props: PublicationFormProps,
) => {
  const { titleArea, publication } = props;
  const {
    publicationType,
    publicationAuthors,
    publicationTitle,
    publicationName,
    applicantRole,
    specificRole,
    publicationStatus,
    publicationDate,
    issuePageArticelNo,
    peerReviewedIndicator,
    citationInfo,
    publicationUrl,
    supportingDocuments,
  } = publication;

  let publicationTypeLabel = getOptionsLabel(
    PublicationTypesOptions,
    publicationType,
  );

  publicationTypeLabel =
    publicationTypeLabel === 'N/A' ? publicationType : publicationTypeLabel;

  const applicantRoleLabel = getOptionsLabel(
    ApplicantRoleOptions,
    applicantRole,
  );
  const publicationStatusLabel = getOptionsLabel(
    PublicationStatusOptions,
    publicationStatus,
  );
  const isNotPaperType = isNotPaper.includes(publicationType);
  const otherRole = applicantRole === ApplicantPublicationRole.OTHER;

  const renderData = [
    {
      label: PUBLICATION.PUBLICATION_TYPE,
      value: publicationTypeLabel,
      isFullWidth: true,
    },
    {
      label: PUBLICATION.PUBLISHER_NAME,
      value: publicationName,
      isFullWidth: true,
    },
    {
      label: PUBLICATION.AUTHORS,
      value: publicationAuthors,
      isFullWidth: true,
    },
    {
      label: PUBLICATION.APPLICANT_ROLE,
      value: isNotPaperType && otherRole ? specificRole : applicantRoleLabel,
    },
    {
      label: PUBLICATION.PUBLICATION_DATE,
      value: publicationDate, // already done the format in query
    },
    {
      label: PUBLICATION.ISSUE_NO,
      value: issuePageArticelNo,
      isFullWidth: true,
    },
    {
      label: PUBLICATION.PEER_REVIEWED,
      value: peerReviewedIndicator ? PUBLICATION.YES : PUBLICATION.NO,
    },
  ];

  const hasFiles = supportingDocuments.length > 0;

  if (!isNotPaperType) {
    renderData.push({
      label: PUBLICATION.PUBLICATION_STATUS,
      value: publicationStatusLabel,
    });
  }

  renderData.push(
    {
      label: PUBLICATION.CITATION_INFO,
      value: citationInfo,
      isFullWidth: true,
    },
    {
      label: PUBLICATION.PUBLICATION_URL,
      value: publicationUrl,
      isFullWidth: true,
    },
  );

  return (
    <Container>
      {titleArea}
      <h2 className="px-8">
        {PUBLICATION.PUBLICATION_TITLE}
        {': '}
        {publicationTitle}
      </h2>
      <div className="grid grid-cols-2 px-8 py-2 text-sm w-full">
        {renderData.map((item, index) => {
          return (
            <div
              key={index}
              className={`py-2 border-b border-solid break-words ${item.isFullWidth && 'col-span-2'}`}
            >
              <span className="text-[#224295]">{item.label}</span>
              :&nbsp;&nbsp;
              {item.value}
            </div>
          );
        })}
      </div>

      <div className="supporting-documents">
        <h3>{APPLICATION_TEXT.SUPPORTING_DOCUMENT}</h3>
        <div className="document-display">
          {hasFiles ? (
            supportingDocuments.map((file, index) => {
              return <DocumentBox key={index} file={file} />;
            })
          ) : (
            <div>
              <p>{APPLICATION_TEXT.NA}</p>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h1 {
    text-align: left !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    margin: 1rem !important;
  }

  h2 {
    font-size: 1rem !important;
    font-weight: 500 !important;
  }

  .supporting-documents {
    padding: 0.5rem 0 0 1rem;

    .document-display {
      padding: 0.5rem 2rem;
    }

    h3 {
      font-style: italic;
      color: #8c8c8c;
    }
  }

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
